export default __webpack_public_path__ + "static/media/customer-amber.e9fb9d14.jpg";